import CryptoJS from "crypto-js";

const secretKey = "clave_secreta_segura"; // Debe ser la misma que usas en Login

export const decryptAES = (cipherText) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Error al desencriptar:", error);
    return null;
  }
};
